import { Bell } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import RichBlock from "@/components/vetting/RichBlock";
import MessageCard, { ForYou, ReviewFlag } from "@/components/appointments/MessageCard";

const tidy = (s) => (s || "").replace(/^(😁|‼️)\s*/u, "").replace(/\s+/g, " ").trim();

function Alternatives({ alt, testid }) {
  if (alt.options.length === 1) {
    const o = alt.options[0];
    return o.messages.map((m, i) => <MessageCard key={i} msg={{ ...m, label: tidy(o.label) }} testid={`${testid}-m${i}`} />);
  }
  return (
    <div className="rounded-xl border border-[#0A1F44]/15 bg-[#F7F5EF] p-2 sm:p-3" data-testid={testid}>
      <div className="text-[11px] text-slate-600 px-1 pb-2">Choose the situation that applies — send only one:</div>
      <Tabs defaultValue="0">
        <TabsList className="h-auto flex-wrap justify-start gap-1 bg-transparent p-0">
          {alt.options.map((o, i) => (
            <TabsTrigger key={i} value={String(i)} data-testid={`${testid}-opt-${i}`}
                         className="rounded-full border border-[#0A1F44]/20 bg-white text-xs whitespace-normal text-left data-[state=active]:bg-[#0A1F44] data-[state=active]:text-white">
              {tidy(o.label)}
            </TabsTrigger>
          ))}
        </TabsList>
        {alt.options.map((o, i) => (
          <TabsContent key={i} value={String(i)} className="mt-3 space-y-3">
            {o.messages.map((m, j) => <MessageCard key={j} msg={m} showLabel={false} testid={`${testid}-opt-${i}-m${j}`} />)}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}

export default function StepCard({ step, testid }) {
  const isTiming = step.kind === "timing";
  return (
    <div className="relative pl-6 sm:pl-8" data-testid={testid}>
      <span className="absolute left-1.5 sm:left-2.5 top-2 w-3 h-3 rounded-full bg-[#C9A961] ring-4 ring-[#C9A961]/20" aria-hidden />
      <div className="space-y-3">
        {isTiming && (
          <div className="flex items-center gap-2 flex-wrap">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-[#0A1F44] text-[#C9A961] text-xs font-semibold px-3 py-1" data-testid={`${testid}-badge`}>
              <Bell className="w-3.5 h-3.5" /> {step.badge}
            </span>
            {step.do_not_skip && <span className="text-[10px] uppercase tracking-[0.2em] text-[#8A1F1F] font-semibold">Do not skip</span>}
          </div>
        )}
        {!isTiming && step.label && <h4 className="font-serif text-base text-[#0A1F44]">{step.label}</h4>}
        {step.body?.length > 0 && <RichBlock runs={step.body} checklist={step.kind === "checklist"} testid={`${testid}-body`} />}
        <ReviewFlag items={step.review} testid={`${testid}-review`} />
        <ForYou runs={step.note} testid={`${testid}-note`} />
        {step.children.map((k, i) => (k.kind === "message"
          ? <MessageCard key={i} msg={k} testid={`${testid}-msg-${i}`} />
          : <Alternatives key={i} alt={k} testid={`${testid}-alt-${i}`} />))}
      </div>
    </div>
  );
}
